import { PhoneCall, Mail, MapPin, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer id="contact" data-testid="site-footer" className="border-t hairline bg-slate2/50">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16 py-16 sm:py-20">
        <div className="grid md:grid-cols-[1.2fr_1fr_1fr] gap-12">
          <div>
            <p className="font-serif text-3xl font-semibold tracking-tight text-ivory">
              ASSU<span className="text-amber inline-block" style={{ transform: "translateY(-0.1em)" }}>–</span>FRANCE
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-ivory/50">
              L'excellence du courtage d'assurance en France. Indépendant,
              humain et résolument moderne — une expertise acquise depuis 2009.
            </p>
            <a
              href="#devis"
              data-testid="footer-quote-cta"
              className="mt-8 inline-flex items-center gap-2 rounded-full border border-amber/50 px-6 py-3 font-mono text-xs uppercase tracking-[0.2em] text-amber transition-all duration-300 hover:bg-amber hover:text-obsidian"
            >
              Démarrer mon étude <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory/40 mb-6">Contact direct</p>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  href="/devis"
                  data-testid="footer-callback-cta"
                  className="flex items-center gap-3 text-ivory/70 hover:text-amber transition-colors"
                >
                  <PhoneCall className="h-4 w-4 text-amber" /> Être rappelé par un conseiller
                </a>
              </li>
              <li>
                <a
                  href="mailto:contact@assu-france.info"
                  data-testid="footer-contact-email"
                  className="flex items-center gap-3 text-ivory/70 hover:text-amber transition-colors"
                >
                  <Mail className="h-4 w-4 text-amber" /> contact@assu-france.info
                </a>
              </li>
              <li className="flex items-start gap-3 text-ivory/50">
                <MapPin className="h-4 w-4 text-amber mt-0.5" />
                1112 Route de Castellar, 06500 Castellar
              </li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory/40 mb-6">Horaires</p>
            <ul className="space-y-3 text-sm text-ivory/60">
              <li className="flex justify-between gap-6"><span>Lundi — Vendredi</span><span className="text-ivory/40">9h00 — 19h00</span></li>
              <li className="flex justify-between gap-6"><span>Samedi</span><span className="text-ivory/40">10h00 — 13h00</span></li>
              <li className="flex justify-between gap-6"><span>Urgences sinistres</span><span className="text-amber">24/7</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col sm:flex-row items-center justify-between gap-4 border-t hairline pt-8">
          <p className="text-xs text-ivory/35">© 2026 ASSU-FRANCE — Courtier en assurance. Tous droits réservés.</p>
          <div className="flex flex-wrap justify-center sm:justify-end gap-x-6 gap-y-3 text-xs text-ivory/35">
            <a href="/mentions-legales/" data-testid="footer-legal-link" className="hover:text-amber transition-colors">Mentions légales</a>
            <a href="/politique-rgpd/" data-testid="footer-privacy-link" className="hover:text-amber transition-colors">Politique RGPD</a>
            <a href="/a-propos/" data-testid="footer-about-link" className="hover:text-amber transition-colors">Votre courtier</a>
            <a href="/courtier-assurance-menton/" data-testid="footer-city-menton-link" className="hover:text-amber transition-colors">Menton</a>
            <a href="/courtier-assurance-nice/" data-testid="footer-city-nice-link" className="hover:text-amber transition-colors">Nice</a>
            <a href="/courtier-assurance-monaco/" data-testid="footer-city-monaco-link" className="hover:text-amber transition-colors">Monaco</a>
            <a href="/courtier-assurance-beausoleil/" data-testid="footer-city-beausoleil-link" className="hover:text-amber transition-colors">Beausoleil</a>
            <span className="font-mono">ORIAS n° 25003318</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
